import { writable } from 'svelte/store';
import type { StoresKey } from '~/stores';

type LunchModalState = {
  isOpen: boolean;
  storeKey: StoresKey | null;
  storeId: number | null;
}

function createLunchModalStore() {
  const { subscribe, set } = writable<LunchModalState>({
    isOpen: false,
    storeKey: null,
    storeId: null
  });

  return {
    subscribe,
    open: (storeKey: StoresKey, storeId: number) => {
      set({ isOpen: true, storeKey, storeId });
    },
    close: () => {
      set({ isOpen: false, storeKey: null, storeId: null });
    }
  };
}

export const lunchModal = createLunchModalStore(); 